<template>
  <a :href="`#${anchor}`">{{ title }}</a>
</template>

<script>
export default {
  name: "Button",
  props: {
    title: {
      type: String,
      required: true
    },
    anchor: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
a {
  border: 0.05em solid #fff;
  border-radius: 1em;
  color: #fff;
  padding: 0.4em 1em;
  font-size: 1.5em;
  cursor: pointer;
  margin: 0 0.5em;
  text-decoration: none;
}

a:hover {
  background: #fff;
  border-color: #00c8b7;
  color: #00c8b7;
}
</style>
